import { listSuggestions } from "../api/ess";
import type { SuggestionListFilters } from "../types/ess";

// The detail leg needs a real suggestion to walk through. A closed one is
// the richest: every gated card (WC + SC evaluations, HOD verification)
// has rendered its read-only record, so the tour shows the whole pipeline
// rather than the two or three cards a freshly-submitted suggestion has.
const CLOSED_STATUS = "implementation_closed";

// The backend lists with `ORDER BY created_at DESC` (ess_service.py) and
// listSuggestions' client-side facet filter preserves that order, so the
// head of the array is always the most recently created.
async function mostRecentId(
  filters: SuggestionListFilters,
): Promise<string | null> {
  try {
    const { suggestions } = await listSuggestions(filters);
    return suggestions[0]?.id ?? null;
  } catch {
    // A failed lookup is treated the same as "nothing to show": the tour
    // drops its detail leg and carries on. Aborting the whole tour on a
    // transient list failure would be a worse trade.
    return null;
  }
}

/**
 * Picks the suggestion the tour's detail leg should open, preferring a
 * closed one and falling back to the most recent of any status. Returns
 * null when the user can see no suggestions at all, in which case the
 * caller drops the leg.
 *
 * Scope comes for free — this goes through the normal list API, so it can
 * only ever return something the user is allowed to open.
 */
export async function resolveDetailTargetId(): Promise<string | null> {
  const closed = await mostRecentId({ status: [CLOSED_STATUS] });
  if (closed) return closed;
  return mostRecentId({});
}
